import { useEffect } from 'react'

const PIXEL_ID = '1320212723322841'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

/**
 * Initializes the Meta (Facebook) Pixel and fires the initial PageView event.
 * Loads the official fbevents.js script only once.
 */
export function useMetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return
    if (window.fbq) return /* eslint-disable */
    ;(function (f: any, b: Document, e: string, v: string) {
      if (f.fbq) return
      const n: any = (f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      })
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = []
      const t = b.createElement(e) as HTMLScriptElement
      t.async = true
      t.src = v
      const s = b.getElementsByTagName(e)[0]
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s)
      } else {
        ;(b.head || b.documentElement).appendChild(t)
      }
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js',
    )
    /* eslint-enable */

    window.fbq('init', PIXEL_ID)
    window.fbq('track', 'PageView')
  }, [])
}
